import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentTitle } from 'components/DocumentTitle';
import { Heading } from 'components/Typography';
import { LearningPathCtx } from 'domains/learning-path/context';
import HelpfulTips from 'domains/learning-path/Components/HelpfulTips';
import KnowledgeCheck from 'domains/learning-path/Components/KnowledgeCheck';
import StrategyOverview from 'domains/learning-path/Components/StrategyOverview';
import { useTrack } from 'utils/hooks/useMixPanel';
import Stepper from 'components/Stepper';
import { LEARNING_PATH_STEPPER_STEP_IDS } from 'domains/learning-path/steps';
import HowToUseIt from 'domains/learning-path/Components/HowToUseIt';
import { PageHeaderCard } from 'components/PageHeaderCard';
import { ContentContainer } from 'components/ContentContainer';
import { ASSIGNMENT_MIXPANEL_EVENTS } from 'domains/assignments/mixpanel';

export const LearningPathUI: React.FC = () => {
  useTrack(ASSIGNMENT_MIXPANEL_EVENTS.viewed.learningPath);
  const { t } = useTranslation();

  const { currentStep, onNavigateToStep, stepsState, learningPath } = useContext(LearningPathCtx);

  const { title } = learningPath;

  return (
    <>
      <DocumentTitle>{t('learningPath.pageTitle')}</DocumentTitle>

      <ContentContainer variant="full">
        <PageHeaderCard textureVariant="orange" className="gap-0">
          <Heading level="h6" as="h2" className="mb-24">
            {t('learningPath.pageTitle')}
          </Heading>
          <Heading level="h2" className="text-center">
            {title}
          </Heading>
        </PageHeaderCard>

        <div className="flex flex-col items-start justify-center w-full max-w-[800px] self-center mb-64">
          <Stepper currentStep={currentStep} onNavigate={onNavigateToStep} className="my-40 sm-d:my-24 w-full">
            {Object.values(LEARNING_PATH_STEPPER_STEP_IDS).map((stepTitle, index) => (
              <Stepper.Step key={stepTitle} index={index} isCompleted={stepsState[index]}>
                {t(`learningPath.steps.title.${stepTitle}`)}
              </Stepper.Step>
            ))}
          </Stepper>

          <StrategyOverview />
          <HowToUseIt />
          <HelpfulTips />
          <KnowledgeCheck />
        </div>
      </ContentContainer>
    </>
  );
};
